import Constants from '../../constants/Constants';
import Helpers from '../../helpers/Helpers';

export const updateIsUserLoggedIn = (isLoggedIn) => {
  let headers = {
    'Content-Type': 'application/json',
  };

  return Helpers.put(`${Constants.USER_URL}/isLoggedIn`, headers, isLoggedIn);
};
